import React from "react";
import PaymentDetailComponent from "@components/User/Payment/PaymentDetail/PaymentDetail";

export default function PaymentDetail() {
  return <PaymentDetailComponent />;
}
